module.exports = __webpack_public_path__ + "static/img/green_button.1436d086.png";